

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { backendUrl } from '../terces';

// const backendUrl = "http://192.168.0.43:5056/api";

export const apiService = createApi({
  reducerPath: "apiService",

  baseQuery: fetchBaseQuery({
    baseUrl: backendUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("Content-Type", "application/json");

      return headers;
    }
  }),
  tagTypes: ['FlexzaiDialerAdmin'],
  endpoints: (builder) => ({
    apiRequest: builder.mutation({
      query: ({ url, method = "GET", data }) => ({
        url,
        method,
        body: data
      }),
      invalidatesTags: (result, error, arg) => {
        if (!arg || !arg.method) return [];
        const method = arg.method.toUpperCase();
        if (["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
          return ["FlexzaiDialerAdmin"];
        }
        return [];
      },
      providesTags: (result, error, arg) => {
        if (!arg || !arg.method) return [];
        const method = arg.method.toUpperCase();
        if (method === "GET") {
          return ["FlexzaiDialerAdmin"];
        }
        return [];
      },
    })
  })
});

export const { useApiRequestMutation } = apiService;